<template>
  <div :class="$style.grid_input">
    <div
      v-if="type === 'number'"
      :class="$style.input_icon"
      @click="calcValue(-1)"
    >
      <svg-sprite
        name="minus-1"
        :size="16"
        :type="'regular'"
      />
    </div>

    <input
      ref="inlineEditorInput"
      class="mousetrap"
      :class="$style.input_text"
      :style="{ textAlign }"
      :value="componentValue"
      maxlength="250"
      @input="onInput"
      @keydown="handleKeyDown"
      @blur="onBlur"
    >

    <div
      v-if="type === 'number'"
      :class="$style.input_icon"
      @click="calcValue(1)"
    >
      <svg-sprite
        name="plus-1"
        :size="16"
        :type="'regular'"
      />
    </div>
  </div>
</template>

<script>
import svgSprite from '$$vueCmp/VueIcon/svgSprite.vue';

export default {
  name: 'GridInput',
  components: { svgSprite },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    type: {
      type: String,
      default: 'text',
      validator: value => ['text', 'number'].includes(value),
    },
    textAlign: {
      type: String,
      default: 'center',
      validator: value => ['start', 'center', 'end'].includes(value),
    },
    maxValue: {
      type: Number,
      default: null,
    },
    minValue: {
      type: Number,
      default: null,
    },
    initialSelect: {
      type: Boolean,
      default: false,
    },
    keepFocus: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    'onInput',
  ],
  data() {
    return {
      componentValue: this.prepareComponentValue(this.value),
    };
  },
  watch: {
    value: {
      handler(val) {
        this.componentValue = this.prepareComponentValue(val);
      },
      immediate: true,
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.inlineEditorInput) {
        if (this.keepFocus) {
          this.$refs.inlineEditorInput.focus();
        }

        if (this.initialSelect) {
          this.$refs.inlineEditorInput.select();
        }
      }
    });
  },
  methods: {
    prepareComponentValue(val) {
      if (!val && this.type === 'number') {
        return 0;
      }

      if (!val) {
        return '';
      }

      return val;
    },

    onInput(event) {
      const value = this.prepareComponentValue(event.target.value);

      this.componentValue = value;
      this.$emit('onInput', value, event.target.selectionStart);
    },

    calcValue(increment) {
      const newValue = Math.round((+this.componentValue + increment) * 100) / 100;

      if (this.maxValue !== null && newValue > this.maxValue) {
        return;
      }

      if (this.minValue !== null && newValue < this.minValue) {
        return;
      }

      this.componentValue = newValue;
      this.$emit('onInput', newValue);
    },

    handleKeyDown(event) {
      if (this.type !== 'number') {
        return;
      }

      let num = 1;

      if (event.altKey) {
        num = 0.1;
      }
      if (event.shiftKey) {
        num = 10;
      }

      if (event.keyCode === 38) {
        event.preventDefault();
        this.calcValue(num);
      }

      if (event.keyCode === 40) {
        event.preventDefault();
        this.calcValue(-num);
      }
    },

    onBlur() {
      // keep focus after instance render
      setTimeout(() => {
        if (this.$refs.inlineEditorInput) {
          this.keepFocus && this.$refs.inlineEditorInput.focus();
        }
      });
    },
  },
};
</script>

<style module src="./input.less" lang="less"></style>
